// modules
import React, { useEffect, useState, useCallback } from 'react';
import { observer } from 'mobx-react';
// components
import { Text, View } from '@upstox/upstox-ui';
// services
import PreRisk from 'modules/PreRisk';
import RoutingService from 'modules/Routing';
// store
import { useStore } from 'modules/Stores';
// typings
import { PreRiskWarningData, Props } from './typings';
// styles
import * as css from './styles';

const SquareOffPreRiskWarning: React.FC<Props> = (
  { basketOrderInstrumentKeys, setSurveillanceData },
) => {
  const [preRiskWarningData, setSurveillanceMessages] =
    useState<PreRiskWarningData[]>([]);
  const [learnMore, setLearnMore] = useState<string>('');
  const [showPreRiskWarning, setShowPreRiskWarning] =
    useState<boolean | null>(null);

  const { getLoading } = useStore('LoadingStore');

  const isPreRiskLoading = getLoading('GET_CHARGES');

  const handleLearnMore = useCallback(() => {
    if (learnMore) {
      RoutingService.openNewUrl(learnMore, '_blank');
    }
  }, [learnMore]);

  useEffect(() => {
    const fetchPreRiskData = async () => {
      const data = await
        PreRisk.getPreRiskWarningForMultipleScrips(basketOrderInstrumentKeys);
      setShowPreRiskWarning(!!data?.openPreRiskModal);
      setSurveillanceData(data?.surveillanceData ?? []);
      setSurveillanceMessages(data?.surveillanceMessages ?? []);
      setLearnMore(data?.learnMore ?? '');
    };
    fetchPreRiskData();
  }, []);

  if (isPreRiskLoading) {
    return <View>Fetching surveillance data...</View>;
  }

  if (!showPreRiskWarning) {
    return null;
  }

  return (
    <View css={css.surveillanceMsgContainer}>
      <View css={css.container}>
        <View css={css.warningBox}>
          <ol style={css.bullets}>
            {preRiskWarningData.map((currentWarning) => (
              <li key={currentWarning.symbol} style={css.instrumentWarning}>
                <span style={css.symbolName}>{currentWarning.symbol}</span>
                {currentWarning.message}
              </li>
            ))}
          </ol>
        </View>
      </View>
      <View css={css.learnMoreContainer}>
        <Text size="s">Do you want to continue?</Text>
        <Text css={css.learnMore} onClick={handleLearnMore}>
          Learn More
        </Text>
      </View>
    </View>
  );
};

export default observer(SquareOffPreRiskWarning);
